<app-bread-crumbs [navigationRoute]="currentRoute" [currentPageString]="currentPageString" [clickHandler]="returnToRFQ"
    (buttonActionHandler)="buttonHandler($event)" [isReadOnly]="false" [breadCrumbFlow]="breadCrumbFlow" [activePage]="activePage">
</app-bread-crumbs>

<app-tagging-validation></app-tagging-validation>

<div class="page-container" *ngIf="permissionData$| async as permissionData">
    <app-layout class="container--form">
        <ng-container *ngIf="tagItemVendorService.tempTagGroup$ | async as tagGroup">
            <section class="section--item mt-2">
                <div class="title">
                    <p class="heading-h6-regular">Item Selection</p>
                </div>
                <div class="action-buttons-wrapper mt-3">
                    <app-button name="Select From Existing Items" type="flat-button" tabindex="0" icon="add"
                        (keypress)="(!isReadOnly) && onSelectExistingItems()"
                        (click)="(!isReadOnly) && onSelectExistingItems()"></app-button>

                    <app-button icon="remove_circle_outline" name="Remove Selected" type="secondary-button" tabindex="0"
                        (keypress)="onRemoveSelectedItems()" (click)="onRemoveSelectedItems()"
                        [disabled]="checkedItemNumbers.length === 0"></app-button>
                </div>
                <div class="content mt-3">
                    <ng-container *ngIf="tagGroup && tagGroup.itemNumbers.length > 0; else noItemTemplate">
                        <app-select-item-table (onSelectedChange)="onItemTableSelectedChange($event)"
                            [selectedItemNumbers]="checkedItemNumbers" [filterItemNumbers]="tagGroup.itemNumbers"
                            [actionsType]="[SelectItemTableAction.DELETE]" (onRowEdit)="onItemRowEdit($event)"
                            (onRowDelete)="onItemRowDelete($event)"
                            [isRemoveRowOnFilter]="true"></app-select-item-table>
                    </ng-container>
                </div>

            </section>
            <section class="section--vendor mt-5">
                <div>
                    <div class="field-info">
                        <p class="mb-1 paragraph-medium-regular"> Do you have vendors to tag? </p>
                    </div>
                    <mat-button-toggle-group (change)="onHasVendorTagChange($event)"
                        [value]="tagGroup.vendors ? HasVendorTag.YES : HasVendorTag.NO">
                        <mat-button-toggle [value]="HasVendorTag.YES">Yes</mat-button-toggle>
                        <mat-button-toggle [value]="HasVendorTag.NO">No</mat-button-toggle>
                    </mat-button-toggle-group>
                </div>

                <ng-container *ngIf="tagGroup && tagGroup.vendors">
                    <div class="title mt-5">
                        <p class="heading-h6-regular">Vendor Selection</p>
                    </div>
                    <div class="action-buttons-wrapper mt-3">
                        <app-button name="Select From Existing Vendors" type="flat-button" tabindex="0" icon="add"
                            (keypress)="(!isReadOnly) && onSelectExistingVendors()"
                            (click)="(!isReadOnly) && onSelectExistingVendors()"></app-button>

                        <app-button icon="add" name="Add Vendor" type="secondary-button" tabindex="0"
                            (keypress)="openVendorSearch(VendorSearchType.NORMAL)"
                            (click)="openVendorSearch(VendorSearchType.NORMAL)" [disabled]="isReadOnly">
                        </app-button>
                        <app-button icon="thumb_up_off_alt" name="Recommend ACL/ASL" type="secondary-button" tabindex="0"
                            (keypress)="openVendorSearch(VendorSearchType.ASL)"
                            (click)="openVendorSearch(VendorSearchType.ASL)" [disabled]="isReadOnly">
                        </app-button>


                        <app-button icon="remove_circle_outline" name="Remove Selected" type="secondary-button"
                            tabindex="0" (keypress)="onRemoveSelectedVendors()" (click)="onRemoveSelectedVendors()"
                            [disabled]="checkedVendorNumbers.length === 0"></app-button>
                    </div>
                    <div class="content mt-3">
                        <ng-container *ngIf="tagGroup && tagGroup.vendors.length > 0; else noVendorTemplate">
                            <app-select-vendor-table (onSelectedChange)="onVendorTableSelectedChange($event)"
                                [selectedVendorNumbers]="checkedVendorNumbers"
                                [filterVendorNumbers]="getFilterVendorNumbers(tagGroup.vendors)"
                                [actionsType]="[SelectVendorTableAction.DELETE]"
                                (onRowDelete)="onVendorRowDelete($event)"
                                [isRemoveRowOnFilter]="true"></app-select-vendor-table>
                        </ng-container>
                    </div>
                </ng-container>
            </section>

            <section class="section--sourcing-status mt-4">
                <div class="form-field">
                    <p class="mb-1 paragraph-medium-regular">Sourcing Status</p>
                    <ng-select class="form-field--sourcing-status" [ngModel]="tagGroup.sourcingStatusId"
                        [items]="sourcingStatusOptions" appearance="outline" bindLabel="name" bindValue="id"
                        (change)="onSourcingStatusChange($event)" [readonly]="!!tagGroup.vendors">
                        <ng-template ng-option-tmp let-item="item">
                            <div
                                [ngClass]="{'is-hidden': item.id === SourcingStatusId.POTENTIAL_VENDOR_IDENTIFIED && tagGroup.sourcingStatusId !== SourcingStatusId.POTENTIAL_VENDOR_IDENTIFIED}">
                                {{ item.name }}
                            </div>
                        </ng-template>
                    </ng-select>
                </div>
            </section>
        </ng-container>
    </app-layout>
</div>

<ng-template #noItemTemplate>
    <app-add-reference-card [desc]="'You have not selected any item yet.'">
    </app-add-reference-card>
</ng-template>

<ng-template #noVendorTemplate>
    <app-add-reference-card [desc]="'You have not selected any vendor yet.'">
    </app-add-reference-card>
</ng-template>